import axios from "axios";

const backEndUrl = process.env.REACT_APP_API_ENDPOINT;

export const checkEmail = ({ payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Bakcned url", backEndUrl)
        console.log("Process.env", process.env)
        let response = await axios.post(`${backEndUrl}/check-email`, payload);
        return resolve(response.data);
      } catch (err) {
        return reject(err);
      }
    });
  };

  export const forgotPassword = ({ payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(`${backEndUrl}/resendForgotEmail`, payload);
        return resolve(response.data);
      } catch (err) {
        return reject(err);
      }
    });
  }


  export const triggerLoginOTP = ({ payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(`${backEndUrl}/login/otp`, payload);
        return resolve(response.data);
      } catch (err) {
        return reject(err);
      }
    });
  };
  

  export const loginViaPassword = ({ payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(`${backEndUrl}/login/password`, payload);
        return resolve(response.data);
      } catch (err) {
        return reject(err);
      }
    });
  };
  

  export const loginViaOTP = ({ payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(`${backEndUrl}/login/verify-otp`, payload);
        return resolve(response.data);
      } catch (err) {
        return reject(err);
      }
    });
  };
  

  export const handleResetPassword = ({ payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(
          `${backEndUrl}/forgetPassword`,
          payload
        );
        return resolve(response.data);
      } catch (err) {
        return reject(err);
      }
    });
  };